import { styled, css } from 'styled-components';
import { colors } from '../../../abstracts/colors';
import { getFontSize } from '../../../abstracts/typography';
import { dontForwardProps } from '../../../util';
export const TextFieldInputElement = styled.input.withConfig(dontForwardProps()).withConfig({
  displayName: "TextFieldInputElement",
  componentId: "asurion-ui-react__sc-3exnw3-0"
})(["position:absolute;border:none;padding:0;padding-top:1.75rem;padding-bottom:0.75rem;box-sizing:border-box;font-size:", ";font-family:inherit;-webkit-appearance:none;outline:0;width:100%;background:none;cursor:inherit;margin:0;", " &:focus,&:active{outline:none;}&:disabled{opacity:1;-webkit-text-fill-color:", ";color:", ";}"], getFontSize(2), ({
  hasIcon
}) => !hasIcon && css(["padding-left:0.75rem;"]), colors.disabledText, colors.disabledText);